var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 81 179",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.369 172.12c-7.0273 3.658-18.725 6.333-28.141 6.259-9.461 0.047-21.132-2.614-28.158-6.289-2.8679-1.505-5.4264-3.652-5.609-6.733-3.2662-47.431-3.2708-107.2 0.05474-154.67 0.23285-3.0696 2.6216-5.9174 5.6599-6.7511 9.2609-2.5175 18.717-3.8685 28.156-3.8552 9.4384 0.013313 18.881 1.3305 28.144 3.8853 3.093 0.89929 5.4263 3.6519 5.6707 6.755 3.2437 47.491 3.2483 107.26-0.1165 154.65-0.2553 3.13-2.7894 5.24-5.6599 6.751z",
    clipRule: "evenodd",
    fill: "url(#f)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.387 173.1c-0.674 0.307-0.9666 1.094-0.591 1.776l0.5383 0.81c0.1794 0.269 0.4431 0.501 0.8361 0.572 4.3619 0.873 8.9207 1.405 13.059 1.376 4.1156 0.03 8.6416-0.477 13.011-1.316 0.3763-0.071 0.6516-0.247 0.8259-0.527l0.5229-0.841c0.3711-0.622 0.1247-1.464-0.5319-1.767-0.1853-0.066-0.3087-0.11-0.5165-0.116l-26.653 6e-3c-0.1627-0.127-0.3313-0.05-0.4998 0.027z",
    fill: "url(#e)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73.492 108.99 5.8948-2.933c0.6116-0.333 1.1181-0.016 0.9902 0.695-0.4148 4.255-1.7411 6.124-5.6121 7.366-0.7114 0.23-1.5018-0.257-1.6193-1.055l-0.2861-3.128c0.0753-0.386 0.2961-0.789 0.6325-0.945z",
    fill: "#5D3CF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m80.409 106.29c-0.1545-0.33-0.523-0.461-0.967-0.205l-5.9032 2.936c-0.3369 0.156-0.558 0.56-0.572 0.968l7.4422-3.699z",
    fill: "#FD5631"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.0283 108.93-5.9004-2.849c-0.59232-0.279-1.1213 0.017-1.0193 0.674 0.35189 4.263 1.679 6.113 5.4772 7.321 0.73819 0.262 1.566-0.273 1.6327-1.008l0.33542-3.124c0.03687-0.469-0.17934-0.822-0.5256-1.014z",
    fill: "#5D3CF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0.11958 106.29c0.13743-0.368 0.51452-0.442 0.985-0.206l5.9155 2.867c0.34714 0.192 0.56389 0.547 0.54981 0.958l-7.4503-3.619z",
    fill: "#FD5631"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m72.674 83.672c0.0536-16.499-0.4769-32.932-1.4055-49.987-0.1048-2.1621-1.8265-4.4906-4.066-5.4277-17.49-7.1389-36.22-7.1819-53.784-0.0225-2.2299 0.9169-3.9163 3.1931-4.0417 5.41-0.98613 17.125-1.5336 33.448-1.5254 49.968-0.00461 11.856 0.28278 23.679 0.74961 35.771 0.10482 2.163 1.7423 4.529 3.9818 5.467 17.978 7.518 37.27 7.556 55.238 0.062 2.2299-0.917 3.9388-3.254 4.0642-5.471 0.5101-12.086 0.7842-23.914 0.7888-35.769z",
    fill: "url(#d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m72.674 83.672c0.0536-16.499-0.4769-32.932-1.4055-49.987-0.1048-2.1621-1.8265-4.4906-4.066-5.4277-17.49-7.1389-36.22-7.1819-53.784-0.0225-2.2299 0.9169-3.9163 3.1931-4.0417 5.41-0.98613 17.125-1.5336 33.448-1.5254 49.968-0.00461 11.856 0.28278 23.679 0.74961 35.771 0.10482 2.163 1.7423 4.529 3.9818 5.467 17.978 7.518 37.27 7.556 55.238 0.062 2.2299-0.917 3.9388-3.254 4.0642-5.471 0.5101-12.086 0.7842-23.914 0.7888-35.769z",
    fill: "#1F1B2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m55.377 173.58c1.2973-0.291 2.5553-0.664 3.7909-0.977l4.2169-45.922c-1.3197 0.351-8.0078 46.899-8.0078 46.899zm-38.185-47.02 4.0985 45.946c1.2574 0.381 2.4756 0.679 3.8172 1.021 0 0-6.6808-46.526-7.9157-46.967z",
    fill: "#FD5631",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m70.485 83.168c0.0021-15.42-0.4396-30.588-1.3579-46.543-0.0881-2.0191-1.6696-4.1605-3.7856-5.0534-16.339-6.6593-33.762-6.6462-50.084-3e-3 -2.0614 0.84-3.641 3.0173-3.7606 5.0307-0.9514 15.904-1.3857 31.17-1.427 46.508 0.0186 11.041 0.2449 22.088 0.6956 33.284 0.0881 2.019 1.6472 4.221 3.7632 5.114 16.704 6.995 34.665 7.037 51.415-2e-3 2.0839-0.9 3.6635-3.077 3.7832-5.091 0.4419-11.151 0.7546-22.142 0.7585-33.244z",
    fill: "#1F1B2D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m65.983 121.59c2.0839-0.901 3.6635-3.078 3.7832-5.092 0.4869-11.272 0.7379-22.285 0.7811-33.305 2e-3 -15.42-0.4397-30.588-1.358-46.543-0.0881-2.0191-1.6696-4.1605-3.7856-5.0535-8.1386-3.3186-16.616-4.976-25.015-4.961l-0.0639 100.18c8.6075-0.01 17.284-1.708 25.658-5.227z",
    fill: "#fff",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m13.641 78.209c0.0065-7.5369 0.3892-15.145 1.1598-23.232 0.1814-1.9913 2.0807-3.7117 4.6977-4.3532 13.63-3.3556 27.976-3.3712 41.622-0.0041 2.6215 0.6624 4.5066 2.3639 4.679 4.3445 0.7679 8.0878 1.1543 15.697 1.1478 23.234 0.0122 5.419-0.1834 10.832-0.6208 16.707-0.1196 2.0134-2.0189 3.7338-4.6584 4.4358-13.99 3.5694-28.751 3.5744-42.723-0.0464-2.6215-0.6623-4.4841-2.4243-4.6564-4.405-0.4554-5.9199-0.6135-11.322-0.6482-16.681z",
    fill: "url(#c)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m62.814 99.271 6.4739 26.027c0.2798 1.128 1.4246 1.811 2.6376 1.559 1.1513-0.274 1.8485-1.395 1.5912-2.584l-6.3844-25.515c-0.0168-0.1431-0.0727-0.3687-0.0894-0.5117l0.0853-46.85c0.0225-0.0605-0.0168-0.1431 0.0058-0.2035l2.1098-24.469c0.0964-1.1992-0.7898-2.2012-1.952-2.2737-1.224-0.0945-2.2466 0.7738-2.3206 1.9126l-2.0931 24.612c-0.0225 0.0605 0.0168 0.143-0.0058 0.2035l-0.0242 47.626c-0.045 0.121-0.0508 0.3246-0.0341 0.4676zm-45.034-48.164-2.101-24.808c-0.1338-1.1444-1.1268-2.0475-2.3565-1.9385-1.168 0.1311-2.0897 1.1041-1.9784 2.309l2.0675 24.522c-0.0225 0.0605 0.0167 0.1431-0.0058 0.2036l-1e-3 46.812c0.0167 0.143-0.0508 0.3245-0.0566 0.5281l-6.3386 25.494c-0.28172 1.133 0.41353 2.272 1.5699 2.548s2.3193-0.405 2.601-1.538l6.4569-26c0.0676-0.1815 0.0509-0.3246 0.0566-0.5281l0.0185-47.422c0.0842-0.0384 0.045-0.121 0.0675-0.1815z",
    fill: "#FD5631"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m40.304 2.6112c3.7843-0.01887 7.5404 0.2263 11.352 0.69708 0.5389 0.05546 0.966-0.34029 0.9384-0.82994 0.0115-0.4071-0.3306-0.80349-0.7461-0.81483-3.8963-0.43234-7.7141-0.69957-11.498-0.6807-3.8462-0.003183-7.6363 0.21924-11.517 0.68365-0.438 0.04915-0.7808 0.40646-0.7306 0.83562 0.0277 0.48965 0.4316 0.90809 0.9538 0.8205 3.7342-0.44803 7.5244-0.67045 11.247-0.71138z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m70.522 169.66c1.4565-1.28 2.0948-3.541 2.0557-6.042l-11.683 8.087c-0.1917 0.139-0.3447 0.361-0.4362 0.605-0.3429 0.915 0.5598 1.857 1.5274 1.509 3.3638-1.156 6.2965-2.466 8.536-4.159zm-52.154 4.377c0.9238 0.328 1.8895-0.573 1.548-1.524-0.0546-0.226-0.2552-0.435-0.4786-0.584l-11.529-7.956c-0.0453 2.54 0.58497 4.767 1.9962 6.027 2.1662 1.666 5.1151 2.919 8.4635 4.037z",
    fill: "url(#b)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m65.18 88.804c0.1714-3.5272 0.272-7.0198 0.268-10.523-0.0269-7.8231-0.3684-15.553-1.1137-23.701-0.0946-1.0619-1.3738-2.1357-3.1084-2.5497-6.7925-1.6726-13.816-2.5366-20.801-2.5644v0.0726c-7.0504-6e-3 -14.102 0.8409-20.906 2.5347-1.7578 0.4002-3.0165 1.5269-3.1297 2.5831-0.7705 8.0865-1.1366 15.838-1.1939 23.699 0.0064 5.6225 0.2205 11.251 0.6199 16.945 0.0328 1.0398 1.3738 2.1357 3.1084 2.5498 13.91 3.5981 28.879 3.6001 42.807 0.0079 1.7803-0.4606 3.0165-1.5269 3.1297-2.5831 0.1171-2.1716 0.2276-4.3258 0.3194-6.4707z",
    clipRule: "evenodd",
    fill: "url(#a)",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4.0156,
    x2: 146.28,
    y1: 178.39,
    y2: 60.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3CF2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5631",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 40.225,
    x2: 40.222,
    y1: 174.7,
    y2: 179.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#628E93",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 40.238,
    x2: 40.308,
    y1: 150.09,
    y2: 24.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 40.261,
    x2: 40.297,
    y1: 111.78,
    y2: 48.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.216,
    x2: 40.275,
    y1: 167.63,
    y2: 179.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#628E93",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.195,
    x2: 48.413,
    y1: 100.55,
    y2: 34.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3CF2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5631",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.84b73f66804a82b56f329679608e1cda.svg";
export { ForwardRef as ReactComponent };